import { SUPPORTED_LANGUAGES, type LanguageCode } from "@/shared/types/language.types"

export { SUPPORTED_LANGUAGES }

export const LANGUAGE_LABEL_KEYS: Record<LanguageCode, string> = {
  en: "language-english",
  ru: "language-russian",
  uk: "language-ukrainian",
  de: "language-german",
  es: "language-spanish",
  fa: "language-persian",
  pl: "language-polish",
  ar: "language-arabic",
  zh: "language-chinese",
  kk: "language-kazakh",
  uz: "language-uzbek",
  hi: "language-hindi"
}
